import React from 'react';
import { Box, Typography } from '@mui/material';

interface BrandMarkProps {
  light?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const SIZES = {
  small: { badge: 32, icon: 18, name: '1.05rem', tagline: '0.6rem' },
  medium: { badge: 40, icon: 22, name: '1.3rem', tagline: '0.7rem' },
  large: { badge: 56, icon: 30, name: '1.75rem', tagline: '0.85rem' },
};

const BrandMark: React.FC<BrandMarkProps> = ({ light = false, size = 'medium' }) => {
  const s = SIZES[size];

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      <Box
        component="img"
        src="/images/logos/medprime-icon-mark.png"
        alt=""
        sx={{
          width: s.badge,
          height: s.badge,
          borderRadius: '10px',
          objectFit: 'cover',
          flexShrink: 0,
        }}
      />
      <Box sx={{ lineHeight: 1 }}>
        <Typography
          component="span"
          sx={{
            display: 'block',
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontWeight: 800,
            fontSize: s.name,
            color: light ? '#fff' : 'primary.dark',
            letterSpacing: '-0.01em',
          }}
        >
          MedPrime
        </Typography>
        <Typography
          component="span"
          sx={{
            display: 'block',
            fontWeight: 600,
            fontSize: s.tagline,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: light ? 'rgba(255,255,255,0.7)' : 'secondary.dark',
          }}
        >
          Benefícios
        </Typography>
      </Box>
    </Box>
  );
};

export default BrandMark;
